import { render } from "./index.vue?vue&type=template&id=51580341"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=51580341&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DashboardGestor/components/DashboardGestorGraficos/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51580341"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51580341', __exports__)) {
    console.log('reload')
    api.reload('51580341', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=51580341", () => {
    console.log('re-render')
    api.rerender('51580341', render)
  })

}


export default __exports__